export default [{
  name: 'signout',
  path: '/signout',
  component: require('@/views/signout/Signout.vue').default
}, {
  name: 'signoutAuto',
  path: '/signout/auto',
  component: require('@/views/signout/Auto.vue').default
}]
